export default __webpack_public_path__ + "static/media/RejectedRelocationIcon.48e33c51.svg";